const initialState = {
  resultsInclusionsCategoriesList: [],
  resultsProductInclusionsCategoriesList: [],
  resultsInclusionsCategory: {},
  resultsInclusionsCategoryAdd: {},
  updateProductInclusionsCategory: {},
  resultsInclusionsCategoryDelete: {},
  loading: false
};

const reducer = (state = initialState, action) => {
  const newState = { ...state };

  switch (action.type) {
    case "GET_LIST_INCLUSIONS_CATEGORY":
    case "GET_PRODUCT_LIST_INCLUSIONS_CATEGORY":
    case "GET_INCLUSIONS_CATEGORY":
    case "CREATE_INCLUSIONS_CATEGORY":
    case "UPDATE_PRODUCT_INCLUSIONS_CATEGORY":
    case "DELETE_PRODUCT_INCLUSIONS_CATEGORY":
      newState.loading = true;
      break;
    case "LIST_INCLUSIONS_CATEGORY_RESPONSE_GET":
      newState.resultsInclusionsCategoriesList = action.value;
      newState.loading = false;
      break;
    case "LIST_PRODUCT_INCLUSIONS_CATEGORY_RESPONSE_GET":
      newState.resultsProductInclusionsCategoriesList = action.value;
      newState.loading = false;
      break;
    case "UPDATE_PRODUCT_INCLUSIONS_CATEGORY_RESPONSE":
      newState.updateProductInclusionsCategory = action.value;
      newState.loading = false;
      break;
    case "INCLUSIONS_CATEGORY_RESPONSE_GET":
      newState.resultsInclusionsCategory = action.value;
      newState.loading = false;
      break;
    case "CREATE_INCLUSIONS_CATEGORY_RESPONSE":
      newState.resultsInclusionsCategoryAdd = action.value;
      newState.loading = false;
      break;
    case "DELETE_PRODUCT_INCLUSIONS_CATEGORY_RESPONSE_GET":

      newState.resultsInclusionsCategoryDelete = action.value;
      newState.loading = false;
      break;
    case "RESET_INCLUSIONS_CATEGORY_RESPONSES":
      newState.resultsInclusionsCategoriesList = [];
      newState.resultsProductInclusionsCategoriesList = [];
      newState.resultsInclusionsCategory = {};
      newState.resultsInclusionsCategoryAdd = {};
      newState.updateProductInclusionsCategory = {};
      newState.resultsInclusionsCategoryDelete = {};
      break;
    default:
      break;
  }
  return newState;
}

export default reducer;
